class Logger {
    print (errorInfo, error) {
        console.group('Error-Boundary');
        console.log(error);
        console.log("Error-Path");
        console.log(errorInfo && errorInfo.componentStack);
    console.groupEnd();
    }
}

export const LoggerServices = new Logger();

